import { render, staticRenderFns } from "./01drugGene.vue?vue&type=template&id=a02e8102&"
import script from "./01drugGene.vue?vue&type=script&lang=js&"
export * from "./01drugGene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports